import { useEffect } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import CatalogPage from './pages/CatalogPage';
import AccountDetailPage from './pages/AccountDetailPage';
import SellWizardPage from './pages/SellWizardPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import BottomNav from './components/BottomNav';
import Toast from './components/Toast';
import { initTelegram } from './lib/telegram';
import { useUserStore } from './store/userStore';
import { useCatalogStore } from './store/catalogStore';

export default function App() {
  const { me, loaded, load } = useUserStore();
  const loadCatalog = useCatalogStore((s) => s.load);

  useEffect(() => {
    initTelegram();
    load();
    loadCatalog();
  }, [load, loadCatalog]);

  if (!loaded) {
    return (
      <div className="mx-auto flex min-h-screen w-full max-w-md items-center justify-center bg-mlbb-bg">
        <div className="text-sm text-white/40">Загрузка...</div>
      </div>
    );
  }

  const isAdmin = me?.role === 'ADMIN';

  return (
    <HashRouter>
      <div className="mx-auto min-h-screen w-full max-w-md bg-mlbb-bg text-white sm:border-x sm:border-mlbb-border">
        <Routes>
          <Route path="/" element={<CatalogPage />} />
          <Route path="/account/:id" element={<AccountDetailPage />} />
          <Route path="/sell" element={<SellWizardPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/admin" element={isAdmin ? <AdminPage /> : <Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <BottomNav isAdmin={isAdmin} />
        <Toast />
      </div>
    </HashRouter>
  );
}
